import { isMultichain } from 'modules/chains/utils/isMultichain';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { AverageRequestsCard } from '../AverageRequestsCard';
import { CachedRequestsCard } from '../CachedRequestsCard';
import { TotalRequestsCard } from '../TotalRequestsCard';
import { TotalTrafficCard } from '../TotalTrafficCard';
import { WidgetSection } from '../WidgetSection';
import { networkUsageTranslation } from './translation';
import { useNetworkUsageStyles } from './useNetworkUsageStyles';

export const NetworkUsage = () => {
  const { isLoggedIn } = useAuth();
  const { chain, chainCallProtocol } = useChainSelectors();

  const { keys, t } = useTranslation(networkUsageTranslation);

  const hasCached = !isLoggedIn && !isMultichain(chain.id);
  const { classes } = useNetworkUsageStyles(hasCached);

  const isGRPC = chainCallProtocol === 'grpc';

  const TotalCard = isGRPC && isLoggedIn ? TotalTrafficCard : TotalRequestsCard;

  return (
    <WidgetSection title={t(keys.title)}>
      <div className={classes.content}>
        <TotalCard className={classes.totalCard} />
        <AverageRequestsCard
          className={classes.averageCard}
          disabled={isGRPC}
        />
        {hasCached && (
          <CachedRequestsCard
            className={classes.cachedCard}
            disabled={isGRPC}
          />
        )}
      </div>
    </WidgetSection>
  );
};
